import { createResource } from "solid-js"
import { RequestsWorker } from "@/lib/requestsWorker"
import { dirHandle } from "./storageShared"

const storage = new RequestsWorker(
  new Worker(new URL("./storageWorker.ts", import.meta.url), {
    type: "module",
  }),
)

const [dataFiles, { refetch: refetchFiles }] = createResource(fetchFiles, {
  initialValue: new Set(),
})

export async function findOrCreate(
  id: string,
  url: string,
  jwt: string | undefined,
) {
  const md = (await storage.send({
    type: "findOrCreate",
    args: { id, url, jwt },
  })) as string
  refetchFiles()
  return md
}

export async function fetchAndSave(
  id: string,
  url: string,
  jwt: string | undefined,
) {
  await storage.send({ type: "fetchAndSave", args: { id, url, jwt } })
  refetchFiles()
  return
}

export async function removeFile(id: string) {
  await storage.send({ type: "removeFile", args: { id } })
  refetchFiles()
  return
}

async function fetchFiles(): Promise<Set<string>> {
  const files: Set<string> = new Set()

  try {
    // TODO: Remove `any` once typescript includes async iterators
    const directoryHandle: any = await dirHandle()
    for await (const name of directoryHandle.keys()) {
      files.add(name)
    }
    return files
  } catch (err) {
    console.error(err)
    return new Set()
  }
}

export const files = dataFiles
